import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { toast } from "sonner";
import { companyFeatures, setCompanyFeature } from "../../api/platform";

export const CompanyFeatures = ({ companyId }) => {
  const { t } = useTranslation();
  const [state, setState] = useState(null);

  useEffect(() => {
    companyFeatures(companyId).then(setState).catch(() => setState(null));
  }, [companyId]);

  const toggle = async (feature, enabled) => {
    const res = await setCompanyFeature(companyId, feature, enabled);
    setState((prev) => ({ ...prev, features: res.features }));
    toast.success(t(enabled ? "features.opened" : "features.closed"));
  };

  if (!state) return null;

  return (
    <div className="mt-4 border-t border-border/50 pt-4" data-testid={`company-features-${companyId}`}>
      <p className="label-xs mb-2">{t("features.title")}</p>
      <div className="flex flex-wrap gap-2">
        {state.keys.map((key) => {
          const on = state.features[key];
          return (
            <button
              key={key}
              type="button"
              data-testid={`feature-toggle-${key}-${companyId}`}
              onClick={() => toggle(key, !on)}
              className={`rounded-full border px-3 py-1.5 text-[11px] font-bold transition-[box-shadow,color] duration-300 ${
                on ? "border-success/50 text-success shadow-neu-in" : "border-border/60 text-muted-foreground shadow-neu-sm"
              }`}
            >
              {t(`features.names.${key}`, { defaultValue: key })} · {t(on ? "features.on" : "features.off")}
            </button>
          );
        })}
      </div>
    </div>
  );
};
